<template>
  <div class="flex items-center space-x-1 md:space-x-3" v-if="property">
    <a
      :href="showPhoneDetails"
      @click="showPhoneNumber(property.id)"
      class="bg-transparent h-[34px] cursor-pointer text-primary py-1 md:px-3 px-1 rounded-lg hover:transition duration-200 ease-in-out border border-primary flex items-center font-normal text-sm"
    >
      <CallSvg color="primary" height="4" width="4" />
      <span v-if="showPhoneInfo" class="ml-1 text-sm">{{
        property.agent.phone
      }}</span>
      <span v-else class="ml-1 text-sm">Call</span>
    </a>
    <button
      @click="sendEmail(property.id)"
      class="bg-transparent h-[34px] cursor-pointer text-primary py-1 md:px-3 px-1 rounded-lg hover:transition duration-200 ease-in-out border border-primary flex items-center font-normal text-sm"
    >
      <EmailSvg color="primary" height="4" width="4" />
      <span class="ml-1 text-sm">Email</span>
    </button>
    <button
      @click="shareWhatsApp(property.id)"
      class="bg-transparent h-[34px] cursor-pointer text-primary py-2 md:px-3 px-1 rounded-lg hover:transition duration-200 ease-in-out border border-primary font-normal text-sm flex items-center"
    >
      <WhatsAppSvg color="primary" height="4" width="4" />
      <span class="ml-1 text-sm">WhatsApp</span>
    </button>

    <div
      class="flex items-center justify-center border-r border-gray-300 h-7"
    ></div>

    <button
      @click="handleAddItem(property)"
      class="bg-transparent h-[34px] cursor-pointer text-primary py-2 md:px-2 px-1 rounded-lg hover:transition duration-200 ease-in-out border border-primary font-normal text-sm flex items-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        :class="{
          'w-4 h-4 md:w-6 md:h-6': !isInWishlist(property),
          'fill-secondary stroke-secondary w-3 h-3 md:w-6 md:h-6':
            isInWishlist(property),
        }"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
        />
      </svg>
    </button>

    <button
      @click="openShareModal(property.id)"
      class="bg-transparent h-[34px] cursor-pointer text-primary py-2 md:px-3 px-1 rounded-lg hover:transition duration-200 ease-in-out border border-primary font-normal text-sm flex items-center"
    >
      <ShareSvg color="primary" height="4" width="4" />
    </button>
    <button
      @click="openReportModal()"
      class="bg-transparent h-[34px] cursor-pointer text-primary py-2 md:px-3 px-1 rounded-lg hover:transition duration-200 ease-in-out border border-primary font-normal text-sm flex items-center"
    >
      <ReportSvg color="primary" height="4" width="4" />
    </button>
  </div>
  <ShareModal
    :content="property"
    :showViewModal="showShareModal"
    @closeViewModal="closeShareModal"
  />

  <ReportModal
    :property_id="property.id"
    :user_id="user_id"
    :showViewModal="showReportModal"
    @closeViewModal="closeReportModal"
  />

  <SignInModal
    :showViewModal="showLoginModal"
    :modalType="modalType"
    @closeViewModal="closeModal"
    @switchModalType="handleSwitchModalType"
  />
</template>

<script>
import { ref, watch } from "vue";
import ShareModal from "./ShareModal.vue";
import ReportModal from "./ReportModal.vue";
import CallSvg from "@/components/svg/CallSvg.vue";
import EmailSvg from "@/components/svg/EmailSvg.vue";
import WhatsAppSvg from "@/components/svg/WhatsAppSvg.vue";
import { state, addItem } from "@/composables/useWishlist";
import useAuth from "@/composables/useAuth";
import SignInModal from "@/components/LoginModal.vue";
import ShareSvg from "@/components/svg/ShareSvg.vue";
import ReportSvg from "@/components/svg/ReportSvg.vue";
import { useProperties } from "@/composables/useProperties";

export default {
  components: {
    CallSvg,
    EmailSvg,
    WhatsAppSvg,
    ShareModal,
    ReportModal,
    SignInModal,
    ShareSvg,
    ReportSvg,
  },
  props: {
    property: Object,
  },
  setup(props) {
    const { state: authState } = useAuth();
    const isAuthenticated = ref(authState.isAuthenticated);
    const user_id = ref("");
    if (isAuthenticated.value) {
      user_id.value = authState.user.id;
    }
    watch(
      () => authState.isAuthenticated,
      (newVal) => {
        isAuthenticated.value = newVal;
      }
    );
    const isDropdownOpen = ref(false);
    const showPhoneInfo = ref(false);
    const showPhoneDetails = ref(null);
    const showEmailDetails = ref(null);
    // const message = ref(null);
    const showLoginModal = ref(false);
    const modalType = ref("");
    const { trackContactRequest, trackShare, trackFavorite } = useProperties();

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const isInWishlist = (property) => {
      return state.wishlist.some((item) => item.id === property.id);
    };

    const handleAddItem = (property) => {
      addItem(property);
      trackFavorite(property.id);
    };

    const showReportModal = ref(false);
    const openReportModal = () => {
      if (isAuthenticated.value == true) {
        showReportModal.value = true;
      } else {
        showLoginModal.value = true;
        modalType.value = "login";
      }
    };

    const closeReportModal = () => {
      showReportModal.value = false;
    };

    const showShareModal = ref(false);
    const openShareModal = (propertyId) => {
      trackShare(propertyId);
      showShareModal.value = true;
    };

    const closeShareModal = () => {
      showShareModal.value = false;
    };

    const shareWhatsApp = (propertyId) => {
      if (isAuthenticated.value == true) {
        trackContactRequest(propertyId);
        const message = `Hi, I found your property with ref: ${props.property.agent.reference} on Hutloop. Please contact me. Thank you.!`;
        const showWhatsAppDetails = `https://api.whatsapp.com/send?phone=${
          props.property.agent.whatsapp_number
        }&text=${encodeURIComponent(message)}`;
        window.open(showWhatsAppDetails, "_blank");
      }
    };

    const showPhoneNumber = (propertyId) => {
      if (isAuthenticated.value == true) {
        trackContactRequest(propertyId);
        showPhoneInfo.value = true;
        showPhoneDetails.value = "tel:" + props.property.agent.phone;
      } else {
        showLoginModal.value = true;
        modalType.value = "login";
      }
    };
    const sendEmail = (propertyId) => {
      if (isAuthenticated.value == true) {
        trackContactRequest(propertyId);
        const showEmailDetails = `mailto:
          ${props.property.agent.email}
          ?subject=Hutloop Property  &body=Hi, I found your property with ref: ${props.property.agent.reference} on Hutloop. Please contact me. Thank you.!`;
        window.open(showEmailDetails);
      } else {
        showLoginModal.value = true;
        modalType.value = "login";
      }
    };

    const closeModal = () => {
      showLoginModal.value = false;
      modalType.value = "";
    };

    const handleSwitchModalType = (type) => {
      modalType.value = type;
    };

    return {
      handleSwitchModalType,
      user_id,
      closeModal,
      showLoginModal,
      modalType,
      showPhoneDetails,
      shareWhatsApp,
      showEmailDetails,
      closeShareModal,
      openShareModal,
      showShareModal,
      closeReportModal,
      openReportModal,
      showReportModal,
      isDropdownOpen,
      showPhoneInfo,
      toggleDropdown,
      showPhoneNumber,
      wishlist: state.wishlist,
      handleAddItem,
      isInWishlist,
      sendEmail,
    };
  },
};
</script>
